/* eslint-disable react/require-default-props */
import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import { Menu } from "../..";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TableHeader = function TableHeader(props) {
  var header = props.header,
    actions = props.actions;
  if ( /*#__PURE__*/isValidElement(header)) {
    return header;
  }
  return /*#__PURE__*/_jsxs(Menu, {
    secondary: true,
    children: [/*#__PURE__*/_jsx(Menu.Item, {
      name: header
    }), actions]
  });
};
TableHeader.handledProps = ["actions", "header"];
TableHeader.propTypes = {
  /** Header. */
  header: PropTypes.node,
  /** Actions. */
  actions: PropTypes.node
};
export default TableHeader;